import useIsMobile from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";
const CategoryPage = dynamic(() => import("@/screens/Category"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
 
import { useRouter } from "next/router";
export default function Category({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  constituencyListData = null,
  electionLiveData = null,
}) {
  const router = useRouter();

  
 

  const isMobileDevice = useIsMobile();

  return (
    <>
      <PageLayout
        rightSideBarData={categoryNewsListData}
        isMobileDevice={isMobileDevice}
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
         electionLiveData={electionLiveData}
      >
        <CategoryPage
          categoryNewsListData={categoryNewsListData}
          isMobileDevice={isMobileDevice}
          electionPassedCategory="assembly-chunav"
          masterKey="bihar_election"
          stateName={"Bihar"} //"Delhi"
          stateHindi={"बिहार"} //"महाराष्ट्र"
          metaData={null}
          constituencyListData={constituencyListData}
          electionLiveData={electionLiveData}
        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    //! this page path could be a subcategory page or a content detail page based on old url
    let url = ctx?.resolvedUrl;
    // redirection
    if (url?.includes("/elections/assembly-chunav?")) {
      return {
        redirect: {
          destination: `${process.env.NEXT_PUBLIC_WEBSITE_URL}/elections/assembly-chunav`,
          permanent: true, // Use `true` for 301 redirection
        },
      };
    }
    //* remove query param from url
    url = url.split("?")[0];

    const { getDataByUrl, getNewUrlByOldUrl, getNewUrlByOldSef } = await import(
      "@/handlers/commonApi"
    );
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { getElectionVideoData } = await import("@/handlers/liveVideo");
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { toBase64 } = await import("@/utils/url");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    let masterConfigData = await getMasterConfig();

let electionConfigData = null;
    const electionConfig = await fetch(
      `${
        process.env.BASE_PATH + process.env.API_PREFIX
      }/staticconfig?id=masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.bihar_election;
    let constituencyListData = null;

    let constituencyUrl =
      electionConfigData?.constListYear == 2020
        ? electionConfigData?.allConstituency2020Api
        : electionConfigData?.allConstituency2025Api;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2020-all-consituency.json`;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("delhi-constitutency", data1);
      constituencyListData = data1; //electionConfigData?.constListYear==2020 ?  data1 : data1?.data;
    });

    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: page,
        display: 12,
        type: "all",
      },
    });
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });
    const redirectUrlRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getnewurl",
        oldUrl: toBase64(url),
      },
    });
 let electionLiveRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "staticconfig", id: "home_livetv_config" },
    });
    let [categoryNewsListData, latestStoryData, latestVideoData, redirectData,electionLiveData] =
      await Promise.all([
        fetchRedisWrapper(categoryListRedisKey, () =>
          getDataByUrl({
            url: url,
            page: page,
            display: 12,
            type: "all",
          })
        ),
        fetchRedisWrapper(latestStoryRedisKey, () =>
          getLatestContentFeed({
            type: "story",
            page: 0,
            display: 5,
            unixtime,
          })
        ),
        fetchRedisWrapper(latestVideoRedisKey, () =>
          getLatestContentFeed({
            type: "video",
            page: 0,
            display: 5,
            unixtime,
          })
        ),
        fetchRedisWrapper(redirectUrlRedisKey, () =>
          getNewUrlByOldUrl({ oldUrl: url })
        ),
        fetchRedisWrapper(electionLiveRedisKey, () => getElectionVideoData()),
      ]);

    //* if redirect data is present then redirect to new url
    // console.log("redirectData", redirectData);
    // console.log("url", url);

    if (redirectData?.url && redirectData?.url?.length > 0) {
      let url = new URL(redirectData.url); //extract pathname from url with query params from url
      let pathname = url.pathname;

      let headerCache = redirectData?.cache;
      setPageTTL(ctx, headerCache?.akamai_ttl);

      return {
        redirect: {
          destination: `${process.env.NEXT_PUBLIC_WEBSITE_URL}` + pathname,
          statusCode: 301,
        },
      };
    }

    //* if categoryNewsListData is null or empty then return not found
    if (
      !categoryNewsListData ||
      Object.keys(categoryNewsListData).length === 0
    ) {
      let sefUrl = ctx?.params?.subcategory;
      // console.log("##Find Article By SefURL##", sefUrl);
      const redirectUrlRedisKey = getRedisApiKey({
        masterConfigData: masterConfigData,
        redisPrefix: "PREFIX_REDIS_ROS",
        params: {
          api: "getnewurl",
          sefUrl: sefUrl,
        },
      });
      let responseData = await fetchRedisWrapper(redirectUrlRedisKey, () =>
        getNewUrlByOldSef({ sefUrl: sefUrl })
      );
      // console.log("res", responseData);
      if (responseData?.url) {
        let url = new URL(responseData.url); //? extract pathname from url with query params from url
        let pathname = url.pathname;

        let headerCache = responseData?.cache;
        setPageTTL(ctx, headerCache?.akamai_ttl);
        return {
          redirect: {
            destination:
              `${process.env.NEXT_PUBLIC_WEBSITE_URL}${isAmp ? "/amp" : ""}` +
              pathname,
            statusCode: 301,
          },
        };
      } else {
        return {
          notFound: true,
        };
      }
    }

    let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 120);
    let stateSlugUrl = url?.split("/election")[0];
    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        stateSlugUrl: stateSlugUrl,
        constituencyListData,electionLiveData
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
